import {
    ShieldCheck,
    BadgePercent,
    Hotel,
    Headphones,
    Zap,
    Gift,
} from "lucide-react";

export default function WhyChooseUs() {
    const features = [
        {
            icon: ShieldCheck,
            title: "Secure Booking",
            description:
                "Your reservations and payments are protected with secure technology.",
        },
        {
            icon: BadgePercent,
            title: "Best Price Guarantee",
            description:
                "We help you find exclusive hotel deals and competitive rates.",
        },
        {
            icon: Hotel,
            title: "Verified Hotels",
            description:
                "Browse trusted hotels, resorts, and apartments across the UAE.",
        },
        {
            icon: Zap,
            title: "Instant Confirmation",
            description:
                "Get quick booking confirmations without waiting for approval.",
        },
        {
            icon: Headphones,
            title: "24/7 Support",
            description:
                "Our support team is available whenever you need assistance.",
        },
        {
            icon: Gift,
            title: "Exclusive UAE Deals",
            description:
                "Access special offers, flash sales, and seasonal hotel discounts.",
        },
    ];

    return (
        <section className="py-24 bg-gradient-to-b from-white to-blue-50 dark:from-gray-950 dark:to-gray-900">
            <div className="container mx-auto px-6">

                {/* Header */}
                <div className="text-center mb-16">

                    <span className="inline-block px-4 py-2 rounded-full bg-blue-100 text-blue-600 text-sm font-semibold mb-4">
                        Why Choose Us
                    </span>

                    <h2 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">
                        Why Travelers Book With Us
                    </h2>

                    <p className="max-w-2xl mx-auto text-gray-600 dark:text-gray-400">
                        Discover trusted hotel deals, secure booking experiences,
                        and exclusive offers across the UAE.
                    </p>
                </div>

                {/* Features */}
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">

                    {features.map((feature, index) => {
                        const Icon = feature.icon;

                        return (
                            <div
                                key={index}
                                className="group bg-white dark:bg-gray-800 rounded-3xl p-8 shadow-lg hover:shadow-2xl hover:-translate-y-2 transition-all duration-500"
                            >
                                {/* Icon */}
                                <div className="w-16 h-16 rounded-2xl bg-gradient-to-r from-blue-600 to-cyan-500 flex items-center justify-center mb-6 group-hover:scale-110 transition">
                                    <Icon
                                        size={30}
                                        className="text-white"
                                    />
                                </div>

                                {/* Content */}
                                <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-3">
                                    {feature.title}
                                </h3>

                                <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                                    {feature.description}
                                </p>
                            </div>
                        );
                    })}
                </div>

                {/* Bottom Stats */}
                <div className="mt-20">

                    <div className="bg-gradient-to-r from-blue-600 via-cyan-500 to-blue-700 rounded-3xl p-10 text-white">

                        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">

                            <div>
                                <h3 className="text-4xl font-bold mb-2">
                                    500+
                                </h3>
                                <p className="text-white/90">
                                    Hotels Listed
                                </p>
                            </div>

                            <div>
                                <h3 className="text-4xl font-bold mb-2">
                                    10K+
                                </h3>
                                <p className="text-white/90">
                                    Happy Travelers
                                </p>
                            </div>

                            <div>
                                <h3 className="text-4xl font-bold mb-2">
                                    7
                                </h3>
                                <p className="text-white/90">
                                    UAE Emirates
                                </p>
                            </div>

                            <div>
                                <h3 className="text-4xl font-bold mb-2">
                                    24/7
                                </h3>
                                <p className="text-white/90">
                                    Customer Support
                                </p>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
        </section>
    );
}